import posthog from 'posthog-js'
import {configuration} from '../../configuration'

export default {
    install(Vue) {
        posthog.init(configuration.posthog.apiKey, {
            'api_host': configuration.posthog.apiHost,
            'person_profiles': 'identified_only'
        })

        Vue.prototype.$posthog = posthog
    }
}